import {
    useEditorPlugin,
    useHotkeys,
    usePluginOption,
} from '@udecode/plate/react';

import { CitationPlugin } from '../../CitationPlugin';

export const useFloatingCitationEscape = () => {
    const { api, editor } = useEditorPlugin(CitationPlugin);

    const open = usePluginOption(CitationPlugin, 'isOpen', editor.id);

    useHotkeys(
        'escape',
        (e) => {
            e.preventDefault();
            editor.tf.focus({ at: editor.selection! });
            api.floatingCitation.hide();
        },
        {
            enabled: open,
            enableOnContentEditable: true,
            enableOnFormTags: ['INPUT'],
        },
        []
    );
};
